@if (access().length > 0) {
  <div class="zf-store">
    <div class="zf-store-chip" [class.open]="open()" [class.static]="access().length < 2"
         (click)="toggle($event)" [title]="current()?.locationName || ''">
      <span class="zf-dot"></span>
      <span class="zf-store-code">{{ current()?.storeCode || '—' }}</span>
      <span class="zf-vsep"></span>
      <span class="zf-store-name">{{ current()?.locationName || current()?.storeName || 'Select location' }}</span>
      @if (access().length > 1) {
        <span class="zf-caret-sm">{{ open() ? '▲' : '▼' }}</span>
      }
    </div>

    @if (open()) {
      <div class="zf-store-panel" (click)="$event.stopPropagation()">
        <div class="zf-panel-head">
          <div class="zf-panel-title-row">
            <span class="zf-panel-title">Switch location</span>
            <span class="zf-pill">{{ access().length }} assigned</span>
          </div>
          <div class="zf-search">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ABAFB9" stroke-width="2" stroke-linecap="round">
              <circle cx="11" cy="11" r="7"></circle><path d="M20 20l-4-4"></path>
            </svg>
            <input #search [value]="query()" (input)="query.set(search.value)"
                   placeholder="Search code, store or city" autofocus />
          </div>
        </div>

        <div class="zf-store-list">
          @for (grp of grouped(); track grp.type) {
            @if (!query()) {
              <div class="zf-store-group">{{ grp.type }}</div>
            }
            @for (a of grp.rows; track a.storeId) {
              <div class="zf-store-row" [class.current]="isCurrent(a)" (click)="pick(a)">
                <div class="zf-mark" [class.on]="isCurrent(a)">{{ isCurrent(a) ? '✓' : '' }}</div>
                <div class="zf-store-main">
                  <div class="zf-store-line">
                    <span class="zf-code">{{ a.storeCode }}</span>
                    <span class="zf-name">{{ a.locationName || a.storeName }}</span>
                    <span class="zf-tag" [class.primary]="a.locationType === 'Warehouse'"
                          [class.ok]="a.locationType !== 'Warehouse'">{{ a.locationType || 'Store' }}</span>
                  </div>
                  @if (a.storeName && a.storeName !== a.locationName) {
                    <div class="zf-meta">{{ a.storeName }}</div>
                  }
                </div>
              </div>
            }
          }
          @if (grouped().length === 0) {
            <div class="zf-empty">No location matches “{{ query() }}”</div>
          }
        </div>

        <div class="zf-panel-foot">
          <span>Switching reloads open documents for the new location.</span>
          <a routerLink="/my-account" (click)="close()">My account</a>
        </div>
      </div>
    }
  </div>
}
